import { BaseModel } from '../../base/base-model'
import { ImageModel } from '../../image/image'

/**
 * @memberOf loavies.models.listing
 * @constructor
 */
export class UpdateListingModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} [title]
   * @param {string} [description]
   * @param {loavies.models.base.PriceModel} [price]
   * @param {number} price.amount
   * @param {string} price.currency
   * @param {loavies.models.image.ImageModel[]|string[]} [images]
   * @param {loavies.models.listing.UpdateListingPrivateDataModel} [privateData]
   * @param {loavies.models.listing.UpdateListingPublicDataModel} [publicData]
   */
  constructor({
    id,
    title,
    description,
    price,
    images,
    privateData,
    publicData,
  }) {

    super()

    /** @type {string} */
    this.id = id

    /** @type {string} */
    if (!this.isUndefined(title)) this.title = title

    /** @type {string} */
    if (!this.isUndefined(description)) this.description = description

    /** @type {loavies.models.base.PriceModel} */
    if (!this.isUndefined(price)) this.price = price

    /** @type {Array<string>} */
    if (!this.isUndefined(images)) this.images = mapImages(images)

    /** @type {loavies.models.listing.UpdateListingPrivateDataModel} */
    if (!this.isUndefined(privateData)) this.privateData = privateData

    /** @type {loavies.models.listing.UpdateListingPublicDataModel} */
    if (!this.isUndefined(publicData)) this.publicData = publicData
  }
}

/**
 * @param {loavies.models.image.ImageModel[]|string[]} images
 * @returns {Array<string>}
 */
function mapImages(images) {
  if (images.length === 0) {
    return []
  }

  if (images[0] instanceof ImageModel) {
    return images.map(image => image?.id)
  }

  return images
}
